import React from 'react';
import { Typography, Box } from '@mui/material';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import SectionCard from '../ui/SectionCard';
import { formatDateTime } from '../../utils/format';

// timeline แนวตั้ง เลียนแบบ StatusHistoryList.js — แต่ละแถวคือการเปลี่ยนผู้รับผิดชอบ 1 ครั้ง
// old_owner_id/new_owner_id เป็น Employee._id (resolve ผ่าน ownerNameById), changed_by เป็น
// User._id (resolve ผ่าน creatorNameByUserId คนละ keyspace — ดู comment ใน OpportunityList.js)
export function OwnerHistoryList({ history, ownerNameById, creatorNameByUserId }) {
  const items = (history || []).slice().reverse();

  return (
    <SectionCard icon={<SwapHorizOutlinedIcon />} title="ประวัติเปลี่ยนผู้รับผิดชอบ" accentColor="grey.500">
      {items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">ยังไม่มีประวัติ</Typography>
      ) : (
        <Box>
          {items.map((h, idx) => (
            <Box key={h.id} sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 12, flexShrink: 0 }}>
                <Box sx={{
                  width: 10, height: 10, borderRadius: '50%', flexShrink: 0, mt: 0.6, bgcolor: 'grey.400',
                }}
                />
                {idx < items.length - 1 && (
                  <Box sx={{ width: '1px', flex: 1, bgcolor: 'divider', my: 0.5 }} />
                )}
              </Box>
              <Box sx={{ pb: idx < items.length - 1 ? 2 : 0 }}>
                <Typography variant="body2">
                  {h.old_owner_id && (
                    <Typography component="span" variant="body2" color="text.secondary">
                      {ownerNameById[h.old_owner_id] || '(ไม่ทราบชื่อ)'}{' → '}
                    </Typography>
                  )}
                  <Typography component="span" variant="body2" fontWeight={700}>
                    {h.new_owner_id ? (ownerNameById[h.new_owner_id] || '(ไม่ทราบชื่อ)') : 'ไม่มีผู้รับผิดชอบ'}
                  </Typography>
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  {formatDateTime(h.changed_at)}
                  {h.changed_by && ` — เปลี่ยนโดย ${creatorNameByUserId[h.changed_by] || '(ไม่ทราบชื่อ)'}`}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </SectionCard>
  );
}

export default OwnerHistoryList;
